import React, { useState, useCallback } from 'react';
import { LoginDialog } from './LoginDialog';
import { useAuth } from '../../core/auth';
import { LoginContext, LoginContextValue, LoginPromptOptions } from './LoginContext';

export interface LoginProviderProps {
  children: React.ReactNode;
}

export function LoginProvider({ children }: LoginProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<LoginPromptOptions>({});
  const { login, signIn } = useAuth();

  const promptLoginModal = useCallback((options: LoginPromptOptions = {}) => {
    setModalProps(options);
    setIsOpen(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setIsOpen(false);
    // Clear props after a brief delay to allow close animation
    setTimeout(() => setModalProps({}), 200);
  }, []);

  const contextValue: LoginContextValue = {
    promptLoginModal,
    closeLoginModal,
  };

  return (
    <LoginContext.Provider value={contextValue}>
      {children}
      <LoginDialog
        isOpen={isOpen}
        onClose={closeLoginModal}
        onLogin={login}
        onSignUp={signIn}
        title={modalProps.title}
        description={modalProps.description}
      />
    </LoginContext.Provider>
  );
}
